
      import { createLanguage, createTranslationFile } from '@vocab/webpack/web';
      
    const translations = createTranslationFile({
      "en": createLanguage(
        require.resolveWeak("./translations.json-en-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJXZWIgYWRkcmVzcyBub3QgYWxsb3dlZCI6IldlYiBhZGRyZXNzIG5vdCBhbGxvd2VkIn0=!"),
        () => import(
          /* webpackChunkName: "en-translations" */
          "./translations.json-en-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJXZWIgYWRkcmVzcyBub3QgYWxsb3dlZCI6IldlYiBhZGRyZXNzIG5vdCBhbGxvd2VkIn0=!"
        )
      ),
"th": createLanguage(
        require.resolveWeak("./translations.json-th-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJXZWIgYWRkcmVzcyBub3QgYWxsb3dlZCI6IuC5hOC4oeC5iOC4reC4meC4uOC4jeC4suC4leC5g+C4q+C5ieC4o+C4sOC4muC4uOC5gOC4p+C5h+C4muC5hOC4i+C4leC5jCJ9!"),
        () => import(
          /* webpackChunkName: "th-translations" */
          "./translations.json-th-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJXZWIgYWRkcmVzcyBub3QgYWxsb3dlZCI6IuC5hOC4oeC5iOC4reC4meC4uOC4jeC4suC4leC5g+C4q+C5ieC4o+C4sOC4muC4uOC5gOC4p+C5h+C4muC5hOC4i+C4leC5jCJ9!"
        )
      ),
"id": createLanguage(
        require.resolveWeak("./translations.json-id-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJXZWIgYWRkcmVzcyBub3QgYWxsb3dlZCI6IkFsYW1hdCB3ZWIgdGlkYWsgZGlpemlua2FuIn0=!"),
        () => import(
          /* webpackChunkName: "id-translations" */
          "./translations.json-id-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJXZWIgYWRkcmVzcyBub3QgYWxsb3dlZCI6IkFsYW1hdCB3ZWIgdGlkYWsgZGlpemlua2FuIn0=!"
        )
      ),
"zh": createLanguage(
        require.resolveWeak("./translations.json-zh-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJXZWIgYWRkcmVzcyBub3QgYWxsb3dlZCI6IldlYiBhZGRyZXNzIG5vdCBhbGxvd2VkIn0=!"),
        () => import(
          /* webpackChunkName: "zh-translations" */
          "./translations.json-zh-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJXZWIgYWRkcmVzcyBub3QgYWxsb3dlZCI6IldlYiBhZGRyZXNzIG5vdCBhbGxvd2VkIn0=!"
        )
      ),
"en-AU": createLanguage(
        require.resolveWeak("./translations.json-en-AU-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJXZWIgYWRkcmVzcyBub3QgYWxsb3dlZCI6IldlYiBhZGRyZXNzIG5vdCBhbGxvd2VkIn0=!"),
        () => import(
          /* webpackChunkName: "en-AU-translations" */
          "./translations.json-en-AU-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJXZWIgYWRkcmVzcyBub3QgYWxsb3dlZCI6IldlYiBhZGRyZXNzIG5vdCBhbGxvd2VkIn0=!"
        )
      ),
"en-HK": createLanguage(
        require.resolveWeak("./translations.json-en-HK-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJXZWIgYWRkcmVzcyBub3QgYWxsb3dlZCI6IldlYiBhZGRyZXNzIG5vdCBhbGxvd2VkIn0=!"),
        () => import(
          /* webpackChunkName: "en-HK-translations" */
          "./translations.json-en-HK-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJXZWIgYWRkcmVzcyBub3QgYWxsb3dlZCI6IldlYiBhZGRyZXNzIG5vdCBhbGxvd2VkIn0=!"
        )
      ),
"en-ID": createLanguage(
        require.resolveWeak("./translations.json-en-ID-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJXZWIgYWRkcmVzcyBub3QgYWxsb3dlZCI6IldlYiBhZGRyZXNzIG5vdCBhbGxvd2VkIn0=!"),
        () => import(
          /* webpackChunkName: "en-ID-translations" */
          "./translations.json-en-ID-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJXZWIgYWRkcmVzcyBub3QgYWxsb3dlZCI6IldlYiBhZGRyZXNzIG5vdCBhbGxvd2VkIn0=!"
        )
      ),
"en-MY": createLanguage(
        require.resolveWeak("./translations.json-en-MY-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJXZWIgYWRkcmVzcyBub3QgYWxsb3dlZCI6IldlYiBhZGRyZXNzIG5vdCBhbGxvd2VkIn0=!"),
        () => import(
          /* webpackChunkName: "en-MY-translations" */
          "./translations.json-en-MY-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJXZWIgYWRkcmVzcyBub3QgYWxsb3dlZCI6IldlYiBhZGRyZXNzIG5vdCBhbGxvd2VkIn0=!"
        )
      ),
"en-NZ": createLanguage(
        require.resolveWeak("./translations.json-en-NZ-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJXZWIgYWRkcmVzcyBub3QgYWxsb3dlZCI6IldlYiBhZGRyZXNzIG5vdCBhbGxvd2VkIn0=!"),
        () => import(
          /* webpackChunkName: "en-NZ-translations" */
          "./translations.json-en-NZ-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJXZWIgYWRkcmVzcyBub3QgYWxsb3dlZCI6IldlYiBhZGRyZXNzIG5vdCBhbGxvd2VkIn0=!"
        )
      ),
"en-PH": createLanguage(
        require.resolveWeak("./translations.json-en-PH-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJXZWIgYWRkcmVzcyBub3QgYWxsb3dlZCI6IldlYiBhZGRyZXNzIG5vdCBhbGxvd2VkIn0=!"),
        () => import(
          /* webpackChunkName: "en-PH-translations" */
          "./translations.json-en-PH-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJXZWIgYWRkcmVzcyBub3QgYWxsb3dlZCI6IldlYiBhZGRyZXNzIG5vdCBhbGxvd2VkIn0=!"
        )
      ),
"en-SG": createLanguage(
        require.resolveWeak("./translations.json-en-SG-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJXZWIgYWRkcmVzcyBub3QgYWxsb3dlZCI6IldlYiBhZGRyZXNzIG5vdCBhbGxvd2VkIn0=!"),
        () => import(
          /* webpackChunkName: "en-SG-translations" */
          "./translations.json-en-SG-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJXZWIgYWRkcmVzcyBub3QgYWxsb3dlZCI6IldlYiBhZGRyZXNzIG5vdCBhbGxvd2VkIn0=!"
        )
      ),
"en-TH": createLanguage(
        require.resolveWeak("./translations.json-en-TH-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJXZWIgYWRkcmVzcyBub3QgYWxsb3dlZCI6IldlYiBhZGRyZXNzIG5vdCBhbGxvd2VkIn0=!"),
        () => import(
          /* webpackChunkName: "en-TH-translations" */
          "./translations.json-en-TH-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJXZWIgYWRkcmVzcyBub3QgYWxsb3dlZCI6IldlYiBhZGRyZXNzIG5vdCBhbGxvd2VkIn0=!"
        )
      ),
"th-TH": createLanguage(
        require.resolveWeak("./translations.json-th-TH-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJXZWIgYWRkcmVzcyBub3QgYWxsb3dlZCI6IuC5hOC4oeC5iOC4reC4meC4uOC4jeC4suC4leC5g+C4q+C5ieC4o+C4sOC4muC4uOC5gOC4p+C5h+C4muC5hOC4i+C4leC5jCJ9!"),
        () => import(
          /* webpackChunkName: "th-TH-translations" */
          "./translations.json-th-TH-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJXZWIgYWRkcmVzcyBub3QgYWxsb3dlZCI6IuC5hOC4oeC5iOC4reC4meC4uOC4jeC4suC4leC5g+C4q+C5ieC4o+C4sOC4muC4uOC5gOC4p+C5h+C4muC5hOC4i+C4leC5jCJ9!"
        )
      ),
"id-ID": createLanguage(
        require.resolveWeak("./translations.json-id-ID-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJXZWIgYWRkcmVzcyBub3QgYWxsb3dlZCI6IkFsYW1hdCB3ZWIgdGlkYWsgZGlpemlua2FuIn0=!"),
        () => import(
          /* webpackChunkName: "id-ID-translations" */
          "./translations.json-id-ID-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJXZWIgYWRkcmVzcyBub3QgYWxsb3dlZCI6IkFsYW1hdCB3ZWIgdGlkYWsgZGlpemlua2FuIn0=!"
        )
      ),
"zh-HK": createLanguage(
        require.resolveWeak("./translations.json-zh-HK-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJXZWIgYWRkcmVzcyBub3QgYWxsb3dlZCI6IldlYiBhZGRyZXNzIG5vdCBhbGxvd2VkIn0=!"),
        () => import(
          /* webpackChunkName: "zh-HK-translations" */
          "./translations.json-zh-HK-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJXZWIgYWRkcmVzcyBub3QgYWxsb3dlZCI6IldlYiBhZGRyZXNzIG5vdCBhbGxvd2VkIn0=!"
        )
      ),
"en-PSEUDO": createLanguage(
        require.resolveWeak("./translations.json-en-PSEUDO-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJXZWIgYWRkcmVzcyBub3QgYWxsb3dlZCI6IlvFtOG6veG6veG6vcOfIMSDxIPEg8aMxozFmeG6veG6veG6vcWhxaEg4LiB4Li14LmJw7bDtsO24bmvIMSDxIPEg8aaxprDtsO2w7bFteG6veG6veG6vcaMXSJ9!"),
        () => import(
          /* webpackChunkName: "en-PSEUDO-translations" */
          "./translations.json-en-PSEUDO-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJXZWIgYWRkcmVzcyBub3QgYWxsb3dlZCI6IlvFtOG6veG6veG6vcOfIMSDxIPEg8aMxozFmeG6veG6veG6vcWhxaEg4LiB4Li14LmJw7bDtsO24bmvIMSDxIPEg8aaxprDtsO2w7bFteG6veG6veG6vcaMXSJ9!"
        )
      )
      });
  
      export { translations as default };
    